import { SORT_ORDER } from '../constants'

export const sortByOrder = ({
    order = SORT_ORDER.ASC,
    options = [],
    key
}) => {
    if (!options || !Array.isArray(options)) return []

    return options.sort((prev, next) => {
        let sortDirection

        if (key && options?.[0][key]) {
            sortDirection = order === SORT_ORDER.ASC
                ? prev[key] > next[key]
                : prev[key] < next[key]
        }

        if (!key) {
            sortDirection = order === SORT_ORDER.ASC
                ? prev > next
                : prev < next
        }

        return sortDirection ? 1 : -1
    })
}